<script setup lang="ts">
import SiteSection from '@/client/components/SiteSection.vue';
import type { TextContent } from '@/client/types';

defineProps<{
    id: string;
    content: TextContent;
}>();
</script>

<template>
    <SiteSection :id="id">
        <div :class="['grid items-center gap-10', { 'md:grid-cols-2': content.image }]">
            <img v-if="content.image" :src="content.image" :alt="content.title ?? ''" class="aspect-[4/3] w-full rounded-2xl object-cover" loading="lazy" />
            <div class="grid gap-4">
                <h2 v-if="content.title" class="text-3xl font-semibold tracking-tight md:text-4xl">{{ content.title }}</h2>
                <p v-if="content.text" class="text-lg leading-relaxed whitespace-pre-line text-muted-foreground">{{ content.text }}</p>
            </div>
        </div>
    </SiteSection>
</template>
